import React from "react";
import './student-score-details.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";

class StudentScoreDetails extends React.Component {

    state = {
        studentDetail: this.props.selectedStudent
    }


    back() {
        this.props.back && this.props.back()
    }

    renderTableRows() {

        let tableRows = [], totalScore = 0

        for (let i = 0; i < this.state.studentDetail.scoreSplitup.length; i++) {
            let item = this.state.studentDetail.scoreSplitup[i]
            totalScore += item.score
            let activity = <tr>
                <td className="teacher-name">
                    <div className="d-flex flex-wrap">
                        {item.title === `Elo's Attempted` ?
                            item.title.replace((`Elo's`), 'Learning Outcomes') : item.title.replace((`ELO's`), 'Learning Outcomes')}
                    </div>
                </td>
                <td className="assignment-count">
                    {item.score}
                </td>
            </tr>

            tableRows.push(activity)
        }

        let total = <tr>
            <td className="total-score-text">
                <div className="d-flex flex-wrap">
                    {'Total Score'}
                </div>
            </td>
            <td className="total-score">
                {totalScore}
            </td>
        </tr>

        tableRows.push(total)

        return tableRows
    }


    renderStudentScoreDetails() {
        return (
            <div className="student-leaderboard-table">
                <table className="table table-bordered" style={{ border: 'none' }}>
                    <thead className="class-header">
                        <tr className="">
                            <th className="first-header-bg" colSpan="100%">
                                <div className="d-flex">
                                    <div className="d-flex align-items-center">
                                        {/* <img className="suit-case-image-size mr-1" src={getImageSource(ImageConstants.WHITE_SUITCASE_ICON)} /> */}
                                        <span className="class-engagement-title">{this.state.studentDetail.name}
                                            {` (${this.state.studentDetail.class}${this.state.studentDetail.section ? ` - ${this.state.studentDetail.section}` : ''})`}</span>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr className="second-header-bg">
                            <th className="" width='30%'>Activity</th>
                            <th className="" width='10%'>Score</th>
                            {/* <th width='10%'>Section</th>
                            <th width='10%'>Rank</th>
                            <th width='10%'>Engagement Score</th> */}
                        </tr>
                    </thead>
                    <tbody id="rows" className="class-body">
                        {
                            this.state.studentDetail && this.state.studentDetail.scoreSplitup &&
                                this.state.studentDetail.scoreSplitup.length ?

                                this.renderTableRows()

                                :
                                <tr>
                                    <td colSpan="5" align='center'> No Records Found</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        return (
            <div className="student-score-details">
                <div ><img className="back-icon cursor-pointer" onClick={() => this.back()} src={getImageSource(ImageConstants.BACK_ICON)} /></div>
                <div className="d-flex align-items-center mt-3">
                    <span className="title">Student Engagement Score </span>
                </div>
                <div className="mt-3">
                    {this.renderStudentScoreDetails()}
                </div>

            </div>
        )
    }

}

export default StudentScoreDetails;